import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.06 3.416c1.608 1.548 2.511 3.646 2.511 5.834H22V12H2V9.25h1.429c0-2.188.903-4.286 2.51-5.834l.116-.11L7 5.126h2.143V1.472a8.87 8.87 0 0 1 5.714 0v3.653H17l.945-1.818c.039.036.078.072.116.11ZM4.042 14c.176 2.104.9 4.159 2.074 5.775C7.48 21.655 9.506 23 12 23s4.519-1.344 5.884-3.225c1.174-1.616 1.898-3.671 2.074-5.775H17.95c-.171 1.706-.77 3.341-1.684 4.6C15.18 20.094 13.706 21 12 21s-3.181-.906-4.266-2.4c-.913-1.259-1.513-2.894-1.684-4.6H4.042Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconPlaceholderBuilder24 = createIcon(IconComponent);